import { Component } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { MunicipalityService } from '../../core/municipality.service';

// Branding bar of the walk-in pages: municipality coat of arms + name | portal name | AUSL logo
@Component({
  selector: 'app-municipality-header',
  standalone: true,
  templateUrl: './municipality-header.component.html',
  imports: [NgIf, AsyncPipe, TranslatePipe],
})
export class MunicipalityHeaderComponent {
  current$ = this.municipalityService.current$;

  constructor(private municipalityService: MunicipalityService) {}
}
